export default __webpack_public_path__ + "static/media/i210hk.73284fb2.webp";